module.exports = __webpack_public_path__ + "img/nydsjzx.6279366d.png";